import React from "react";
import { useLang } from "@/i18n/LanguageContext";

const CULINARY_IMAGE =
  "https://i.ibb.co/08rsxZP/Pareja-desayunando.png";

export default function Culinary() {
  const { t } = useLang();
  const ritual = t("culinary.ritual");
  const tastingSteps = t("culinary.tasting_steps");

  return (
    <section
      id="cocina"
      data-testid="culinary-section"
      className="relative bg-cream-100 py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6 lg:sticky lg:top-32">
          <span className="text-[11px] uppercase tracking-[0.32em] text-gold-deep font-medium">
            {t("culinary.overline")}
          </span>
          <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] text-olive-900 font-medium">
            {t("culinary.h2_a")} <br />
            {t("culinary.h2_b")} <span className="italic">{t("culinary.h2_c")}</span>.
          </h2>
          <p className="mt-8 text-base sm:text-lg leading-relaxed text-olive-800/80 font-light max-w-md">
            {t("culinary.body")}
          </p>

          <div className="mt-10 aspect-[4/5] overflow-hidden">
            <img
              src={CULINARY_IMAGE}
              alt={t("culinary.image_alt")}
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="lg:col-span-6 lg:pl-8">
          <div className="space-y-10">
            {ritual.map((r) => (
              <div
                key={r.step}
                className="group grid grid-cols-[auto_1fr] gap-6 border-b border-cream-400 pb-10 last:border-0"
              >
                <div className="font-serif italic text-5xl text-gold-deep leading-none">
                  {r.step}
                </div>
                <div>
                  <h3 className="font-serif text-2xl text-olive-900">{r.title}</h3>
                  <p className="mt-3 text-olive-800/80 font-light leading-relaxed">
                    {r.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-14 bg-olive-800 text-cream-100 p-8 sm:p-10">
            <div className="text-[10px] uppercase tracking-[0.3em] text-gold mb-4">
              {t("culinary.tasting_title")}
            </div>
            <ol className="space-y-4 font-light text-cream-100/85 leading-relaxed">
              {tastingSteps.map((s, i) => (
                <li key={s}>
                  <span className="text-gold mr-2">
                    0{i + 1} —
                  </span>
                  {s}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
